import React, { type HTMLAttributes, type PropsWithChildren } from 'react';
import cx from 'classnames';
import stylesheet from './Modal.css';

const ModalContent: React.FC<
  PropsWithChildren & HTMLAttributes<HTMLElement>
> = ({ children, className, ...rest }) => {
  return (
    <div className={cx(stylesheet.content, className)} {...rest}>
      {children}
    </div>
  );
};

export default ModalContent;
